module.exports = __webpack_public_path__ + "static/media/prestamo.270fb9f2.svg";